/**
 * EFFET : bruit de claque synthétisé (aucun fichier audio) — souffle de bruit filtré
 * à attaque sèche + petit « bomp » grave. Le contexte audio n'est créé qu'après un
 * geste de l'utilisateur (politique d'autoplay des navigateurs).
 */
export interface SlapSound {
  /** À appeler depuis un geste (clic) : autorise le son pour la suite de la partie. */
  unlock(): void;
  play(): void;
}

export function createSlapSound(): SlapSound {
  let ctx: AudioContext | null = null;
  return {
    unlock() {
      try {
        ctx ??= new AudioContext();
        void ctx.resume();
      } catch {
        ctx = null; // pas d'audio : la tapette reste visuelle
      }
    },
    play() {
      if (!ctx || ctx.state !== 'running') return;
      const now = ctx.currentTime;
      const length = Math.floor(ctx.sampleRate * 0.25);
      const buffer = ctx.createBuffer(1, length, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      for (let i = 0; i < length; i++) data[i] = Math.random() * 2 - 1;
      const noise = ctx.createBufferSource();
      noise.buffer = buffer;
      const band = ctx.createBiquadFilter();
      band.type = 'bandpass';
      band.frequency.value = 1400;
      band.Q.value = 0.8;
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(0.9, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.18);
      noise.connect(band).connect(gain).connect(ctx.destination);
      noise.start(now);
      noise.stop(now + 0.25);

      const thump = ctx.createOscillator();
      thump.frequency.setValueAtTime(140, now);
      thump.frequency.exponentialRampToValueAtTime(55, now + 0.12);
      const tg = ctx.createGain();
      tg.gain.setValueAtTime(0.6, now);
      tg.gain.exponentialRampToValueAtTime(0.001, now + 0.14);
      thump.connect(tg).connect(ctx.destination);
      thump.start(now);
      thump.stop(now + 0.15);
    },
  };
}
